import {
  Tab,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs,
  Tooltip
} from "@material-ui/core";
import _ from "lodash";
import * as React from "react";
import ReactPaginate from "react-paginate";
import { connect } from "react-redux";
import { formatMoneyValue } from "src/utils/formatters";
import { v4 as uuid } from "uuid";
import selectorsToProps from "../utils/selectorsToProps";
import "./AuditLogTable.scss";
import { AuditLogData, LogEntry } from "./types";

interface AuditLogTableProps {
  history: AuditLogData;
  page: number;
  orderBy?: string;
  order?: "asc" | "desc";
  activeTab?: number;
  updatePageFn: (params: any) => void;
  updateSortFn: (event: any, property: string) => void;
  updateTabFn: (event: object, newValue: number) => void;
  pageSize: number;
}

export class AuditLogTable extends React.Component<AuditLogTableProps> {
  public tableColumnsConfig = [
    {
      id: "changeType",
      name: "Change Type",
      sortable: true,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "documentType",
      name: "Document Type",
      sortable: true,
      inTabs: [0, 2, 3]
    },
    {
      id: "description",
      name: "Value",
      sortable: false,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "timePeriod",
      name: "Time Period",
      sortable: true,
      inTabs: [0, 2, 3]
    },
    {
      id: "from",
      name: "From",
      sortable: false,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "to",
      name: "To",
      sortable: false,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "updatedBy",
      name: "Updated By",
      sortable: true,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "team",
      name: "Team",
      sortable: false,
      inTabs: [0, 1, 2, 3]
    },
    {
      id: "dateTime",
      name: "Date/Time",
      sortable: true,
      inTabs: [0, 1, 2, 3]
    }
  ];

  constructor(props: AuditLogTableProps) {
    super(props);
  }

  public render() {
    const { activeTab } = this.props;
    return (
      <>
        <Tabs
          className="AuditLogTable__tabs"
          value={activeTab}
          onChange={this.props.updateTabFn}
          classes={{ indicator: "" }}
        >
          <Tab
            className="AuditLogTable__tab"
            label="ALL"
            classes={{
              labelContainer: "AuditLogTable__tab",
              selected: "AuditLogTable__tab--selected"
            }}
            disableRipple={true}
          />

          <Tab
            className="AuditLogTable__tab"
            label="Statement"
            classes={{
              labelContainer: "AuditLogTable__tab--container",
              selected: "AuditLogTable__tab--selected"
            }}
            disableRipple={true}
          />
          {this.periodOptions().map((period, index) => {
            return (
              <Tab
                key={period}
                className="AuditLogTable__tab"
                label={`Period ${index + 1}`}
                classes={{
                  labelContainer: "AuditLogTable__tab--container",
                  selected: "AuditLogTable__tab--selected"
                }}
                disableRipple={true}
              />
            );
          })}
        </Tabs>
        <div className={"auditLogPageContainer"}>
          <div className="auditLogTableContainerDiv">
            <Table className="table auditLogTable" padding="dense">
              {this.tableHeaders()}
              <TableBody>
                {_.flatMap(this.allHistory(), logEntry =>
                  this.tableRow(logEntry)
                )}
              </TableBody>
            </Table>
          </div>

          <ReactPaginate
            previousLabel={""}
            nextLabel={""}
            breakLabel={""}
            breakClassName={"break-me"}
            initialPage={0}
            forcePage={this.props.page}
            pageCount={this.props.history.totalLogEntries / this.props.pageSize}
            marginPagesDisplayed={1}
            pageRangeDisplayed={5}
            onPageChange={this.props.updatePageFn}
            containerClassName={"AuditLogPagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disableInitialCallback={true}
          />
        </div>
      </>
    );
  }

  public createSortHandler = property => event => {
    this.props.updateSortFn(event, property);
  };

  private allHistory() {
    const periodLogEntries = _.flatMap(
      this.props.history.periods || [],
      period =>
        _.map(period.logEntries || [], entry => {
          entry.period = period.period;
          return entry;
        })
    );

    const entries = Array.prototype.concat(
      periodLogEntries,
      this.props.history.logEntries
    );

    // const orderBy = this.props.orderBy || "logEntryTimestamp";
    // entries = _.sortBy(entries, [orderBy]);

    // if (this.props.order === "desc") {
    //   entries = _.reverse(entries);
    // }

    return entries;
  }

  private tableRow(logEntry: LogEntry) {
    if (
      logEntry.action === "Changed Spread Metadata" &&
      logEntry.previousState.fields
    ) {
      return _.map(logEntry.previousState.fields || {}, (value, key) => {
        const newValue = logEntry.currentState.fields[key];

        if (this.props.activeTab === 2 || this.props.activeTab === 3) {
          return (
            <TableRow key={uuid()} className={"auditLogRow"}>
              <TableCell>{logEntry.action}</TableCell>
              <TableCell>
                {logEntry.currentState.statementType || "N/A"}
              </TableCell>
              <TableCell>{key}</TableCell>
              <TableCell>{logEntry.period || "N/A"}</TableCell>
              <TableCell>{value}</TableCell>
              <TableCell>{newValue}</TableCell>
              <TableCell>{logEntry.username}</TableCell>
              <TableCell>{logEntry.team}</TableCell>
              <TableCell>{logEntry.logEntryTimestamp}</TableCell>
            </TableRow>
          );
        } else if (this.props.activeTab === 1) {
          return (
            <TableRow key={uuid()} className={"auditLogRow"}>
              <TableCell>{logEntry.action}</TableCell>
              <TableCell>{key}</TableCell>
              <TableCell>{value}</TableCell>
              <TableCell>{newValue}</TableCell>
              <TableCell>{logEntry.username}</TableCell>
              <TableCell>{logEntry.team}</TableCell>
              <TableCell>{logEntry.logEntryTimestamp}</TableCell>
            </TableRow>
          );
        } else {
          return (
            <TableRow key={uuid()} className={"auditLogRow"}>
              <TableCell>{logEntry.action}</TableCell>
              <TableCell>
                {logEntry.currentState.statementType || "N/A"}
              </TableCell>
              <TableCell>{key}</TableCell>
              <TableCell>{logEntry.period || "N/A"}</TableCell>
              <TableCell>{value}</TableCell>
              <TableCell>{newValue}</TableCell>
              <TableCell>{logEntry.username}</TableCell>
              <TableCell>{logEntry.team}</TableCell>
              <TableCell>{logEntry.logEntryTimestamp}</TableCell>
            </TableRow>
          );
        }
      });
    } else if (logEntry.action === "Changed Spread Status") {
      if (this.props.activeTab === 1) {
        return (
          <TableRow key={uuid()} className={"auditLogRow"}>
            <TableCell>{logEntry.action}</TableCell>
            <TableCell>{this.props.history.fileName}</TableCell>
            <TableCell>{logEntry.previousState.spreadStatus}</TableCell>
            <TableCell>{logEntry.currentState.spreadStatus}</TableCell>
            <TableCell>{logEntry.username}</TableCell>
            <TableCell>{logEntry.team}</TableCell>
            <TableCell>{logEntry.logEntryTimestamp}</TableCell>
          </TableRow>
        );
      } else {
        return (
          <TableRow key={uuid()} className={"auditLogRow"}>
            <TableCell>{logEntry.action}</TableCell>
            <TableCell>
              {logEntry.currentState.statementType || "N/A"}
            </TableCell>
            <TableCell>{this.props.history.fileName}</TableCell>
            <TableCell>{logEntry.period || "N/A"}</TableCell>
            <TableCell>{logEntry.previousState.spreadStatus}</TableCell>
            <TableCell>{logEntry.currentState.spreadStatus}</TableCell>
            <TableCell>{logEntry.username}</TableCell>
            <TableCell>{logEntry.team}</TableCell>
            <TableCell>{logEntry.logEntryTimestamp}</TableCell>
          </TableRow>
        );
      }
    } else if (logEntry.action === "Changed Account Mapping") {
      return (
        <TableRow key={uuid()} className={"auditLogRow"}>
          <TableCell>{logEntry.action}</TableCell>
          <TableCell>{logEntry.currentState.statementType || "N/A"}</TableCell>
          <TableCell>{logEntry.previousState.childAccountName}</TableCell>
          <TableCell>{logEntry.period}</TableCell>
          <TableCell>{logEntry.previousState.accountName}</TableCell>
          <TableCell>{logEntry.currentState.accountName}</TableCell>
          <TableCell>{logEntry.username}</TableCell>
          <TableCell>{logEntry.team}</TableCell>
          <TableCell>{logEntry.logEntryTimestamp}</TableCell>
        </TableRow>
      );
    } else {
      return (
        <TableRow key={uuid()} className={"auditLogRow"}>
          <TableCell>{logEntry.action}</TableCell>
          <TableCell>{logEntry.currentState.statementType || "N/A"}</TableCell>
          <TableCell>{logEntry.previousState.accountName}</TableCell>
          <TableCell>{logEntry.period || "N/A"}</TableCell>
          <TableCell>
            {logEntry.previousState.accountValue &&
              formatMoneyValue(logEntry.previousState.accountValue)}
          </TableCell>
          <TableCell>
            {logEntry.currentState.accountValue &&
              formatMoneyValue(logEntry.currentState.accountValue)}
          </TableCell>
          <TableCell>{logEntry.username}</TableCell>
          <TableCell>{logEntry.team}</TableCell>
          <TableCell>{logEntry.logEntryTimestamp}</TableCell>
        </TableRow>
      );
    }
  }

  private tableHeaders() {
    const { order, orderBy, activeTab } = this.props;

    return (
      <TableHead>
        <TableRow>
          {this.tableColumnsConfig
            .map(column => {
              if (column.sortable && _.includes(column.inTabs, activeTab)) {
                return (
                  <TableCell
                    key={column.id}
                    sortDirection={column.sortable ? order : false}
                    className={"tableHeader"}
                  >
                    <Tooltip
                      title="Sort"
                      placement={true ? "bottom-end" : "bottom-start"}
                      enterDelay={300}
                    >
                      <TableSortLabel
                        active={orderBy === column.id}
                        direction={order}
                        onClick={this.createSortHandler(column.id)}
                      >
                        {column.name}
                      </TableSortLabel>
                    </Tooltip>
                  </TableCell>
                );
              } else if (_.includes(column.inTabs, activeTab)) {
                return (
                  <TableCell key={uuid()} className={"tableHeader"}>
                    {column.name}
                  </TableCell>
                );
              } else {
                return null;
              }
            })
            .filter(element => element)}
        </TableRow>
      </TableHead>
    );
  }

  private periodOptions() {
    return this.props.history.periods.map(period => period.period);
  }
}

export default connect(
  selectorsToProps({}),
  {}
)(AuditLogTable);



// WEBPACK FOOTER //
// ./src/auditLog/AuditLogTable.tsx